<div class="modal-header">
    <h4 class="modal-title pull-left">{{ title | translate }}</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span>&times;</span>
    </button>
</div>

<div class="modal-body">
    <p>{{ subtitle | translate }}</p>

    <div>
        <input class="form-control mb-3" [placeholder]="'filtre.searchPlaceholder' | translate" type="text" [formControl]="searchForm" />

        <app-loader></app-loader>

        <div class="mb-3 result-list" (scroll)="scroll($event)">
            <dts-select-container
                class="form-group form-group-custom-control"
                [selectMode]="false"
                [selectOnDrag]="true"
                [dragOverItems]="true"
                (selectionEnded)="handleDragSelection($event, type)">

                <div [hidden]="isSearching">
                    <p *ngIf="(itemsForm.value | keyvalue).length === 0 || (searchForm.value !== '' && filteredList.length === 0)">{{ 'filtre.noResult' | translate }}</p>

                    <div *ngIf="!(searchForm.value !== '' && filteredList.length === 0)" class="custom-control custom-checkbox">
                        <input
                            id="selectAllItemsCheckboxesModal"
                            class="custom-control-input form-check-input"
                            type="checkbox"
                            [formControl]="searchForm.value !== '' ? newAllCheckboxForm : allCheckboxForm"
                        />
                        <label class="custom-control-label select-all" for="selectAllItemsCheckboxesModal">{{ "filtre.selectAll" | translate }} </label>
                    </div>

                    <div [formGroup]="itemsForm">
                        <div *ngFor="let item of itemsForm.value | keyvalue; let i = index"
                            class="custom-control custom-checkbox"
                            [hidden]="searchForm.value !== '' && !filteredList.includes(item.key)"
                            [dtsSelectItem]="item">
                            <input
                                id="customCheckboxItemModal{{ i }}"
                                class="custom-control-input form-check-input"
                                type="checkbox"
                                [formControlName]="item.key"
                                [value]="item.value"
                            />
                            <label class="custom-control-label" for="customCheckboxItemModal{{ i }}">{{ item.key }}</label>
                        </div>
                    </div>
                </div>

            </dts-select-container>
        </div>
    </div>
</div>

<div class="modal-footer">
    <div class="btn-group">
        <button type="button" class="btn btn--ghost btn--default" (click)="reinitialize()">{{ "filtre.bouton.reinitialiser" | translate }}</button>
        <button type="submit" class="btn btn--plain btn--primary" (click)="filter()">{{ "filtre.bouton.filtrer" | translate }}</button>
    </div>
</div>
